module.exports = __webpack_public_path__ + "img/binance-metamask-begin.3a0eb798.png";